﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'ca-credit-evaluation',
    props: ['viewmodel', 'editmode'],
    data: () => ({
        VATMultiplyer: 0.2,
        dataLabel: 'Recommended'
    }),
    mounted: function () {
        this.$store.dispatch('setTexts', {
            'creditCheck': this.viewmodel.getCreditCheckResultErrorMessage
        });

        this.$store.dispatch('setPageLoaderTexts', {
            'loaderSetCreditCheckNewCreditLimitLoaderTitle': this.viewmodel.setCreditCheckNewCreditLimitLoaderTitle,
            'loaderSetCreditCheckNewCreditLimitLoaderMessage': this.viewmodel.setCreditCheckNewCreditLimitLoaderMessage
        });

        this.$store.watch(state => state.creditaccount.preAuth.stored, (newState) => {
            this.disableCreditLimits(this.totalCredit);
        });

        this.$store.watch(state => state.creditaccount.creditAgreement.totalCredit, (newTotal) => {
            this.disableCreditLimits(newTotal);
        });

        this.$store.watch(state => state.creditaccount.creditEvaluation.approvedWithLowerLimit, (approvedLimit) => {
            this.setDataForApprovedLimit(approvedLimit);
        });

        document.getElementById("ca-decision-wrap").classList.remove("ca-temp-hide");
    },
    methods: {
        setDataForApprovedLimit: function (approvedLimit) {
            if (approvedLimit > 0) {
                var radioButtons = document.getElementsByName("availableCreditLimit");
                for (var i = 0; i < radioButtons.length; i++) {
                    if (radioButtons[i]._value === approvedLimit) {
                        radioButtons[i].checked = true;
                        this.setNewCreditLimit(approvedLimit);
                    }
                }
            }
        },
        disableCreditLimits: function (totalCreditLimit) {
            const totalLoanAmount = totalCreditLimit + this.preAuth.creditLimit - this.preAuth.availableAmount
            var radioButtons = document.getElementsByName("availableCreditLimit");
            for (var i = 0; i < radioButtons.length; i++) {
                const disable = radioButtons[i].value < totalLoanAmount;
                radioButtons[i].disabled = disable;
            }
        },
        setNewCreditLimit: function (amount) {
            var newCreditLimit = { 'amount': amount, 'currency': 'DKK', 'vat': Number((amount * this.VATMultiplyer).toFixed(2)) }
            this.$store.dispatch('setCreditCheckNewCreditLimit', newCreditLimit);
        },
        recommendedCreditLimit: function () {
            const loanAmount = this.totalCredit + this.preAuth.creditLimit - this.preAuth.availableAmount;
            for (let i = 0; i < this.preAuth.availableCreditLimits.length; i++) {
                if (this.preAuth.availableCreditLimits[i] >= loanAmount) {
                    return this.preAuth.availableCreditLimits[i];
                }
            }
        },
        performCreditCheck: function () {
            this.$store.dispatch('externalCreditCheck', {
                'requestedLimit': this.creditEvaluation.selectedCreditLimit,
                'loaderTitle': this.viewmodel.getCreditCheckLoaderTitle,
                'loaderMessage': this.viewmodel.getCreditCheckLoaderMessage
            });
        },
        getCreditLimitClass: function (limitItem) {
            let className = '';
            const recommendedCreditLimit = this.recommendedCreditLimit();
            const approvedCreditLimit = this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;

            if (approvedCreditLimit > 0) {
                if (recommendedCreditLimit === limitItem && recommendedCreditLimit < approvedCreditLimit) {
                    className = 'recommendedCreditLimit';
                }
                if (recommendedCreditLimit === limitItem && recommendedCreditLimit > approvedCreditLimit) {
                    className = 'requiredCreditLimit';
                }
                if (approvedCreditLimit === limitItem) {
                    className = 'approvedCreditLimit';
                }
            }
            else {
                if (recommendedCreditLimit === limitItem) {
                    className = 'recommendedCreditLimit';
                }
            }

            return className;
        },
        setTooltipParagraph: function (tooltipText) {
            return '[{"paragraph":"' + tooltipText + '"}]';
        },
        showAccepted: function () {
            const approved = this.creditEvaluation.creditCheckResult.approved;
            const showDecision = this.creditEvaluation.creditCheckResult.showDecision;
            const approvedWithLowerLimit = this.creditEvaluation.approvedWithLowerLimit;
            const higherCreditLimitNeeded = this.showHigherCreditLimitNeeded();

            if (approved && showDecision && approvedWithLowerLimit === 0 && !higherCreditLimitNeeded) {
                return true;
            }
            return false;
        },
        showHigherCreditLimitNeeded: function () {
            const approved = this.creditEvaluation.creditCheckResult.approved;
            const showDecision = this.creditEvaluation.creditCheckResult.showDecision;
            const approvedLimit = this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;
            const availableAmount = approvedLimit - (this.preAuth.creditLimit - this.preAuth.availableAmount);
            const approvedWithLowerLimitInsufficientFunds = this.showApprovedWithLowerLimitInsufficientFunds();

            if (approved && showDecision && availableAmount < this.totalCredit && !approvedWithLowerLimitInsufficientFunds) {
                return true;
            }
            return false;
        },
        showApprovedWithLowerLimitInsufficientFunds: function () {
            const approved = this.creditEvaluation.creditCheckResult.approved;
            const showDecision = this.creditEvaluation.creditCheckResult.showDecision;
            const approvedWithLowerLimit = this.creditEvaluation.approvedWithLowerLimit;
            const availableAmount = this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount - (this.preAuth.creditLimit - this.preAuth.availableAmount);

            if (approved && showDecision && approvedWithLowerLimit > 0 && availableAmount < this.totalCredit) {
                return true;
            }
            return false;
        },
        showApprovedWithLowerLimitSufficientFunds: function () {
            const approved = this.creditEvaluation.creditCheckResult.approved;
            const showDecision = this.creditEvaluation.creditCheckResult.showDecision;
            const approvedWithLowerLimit = this.creditEvaluation.approvedWithLowerLimit;
            const availableAmount = this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount - (this.preAuth.creditLimit - this.preAuth.availableAmount);

            if (approved && showDecision && approvedWithLowerLimit > 0 && availableAmount >= this.totalCredit) {
                return true;
            }
            return false;
        },
        showMaxCreditLimitReached: function () {
            const maxCreditLimit = this.preAuth.availableCreditLimits[this.preAuth.availableCreditLimits.length - 1];
            if (this.preAuth.creditLimit === maxCreditLimit && this.totalCredit > this.preAuth.availableAmount) {
                return true;
            }
            return false;
        }
    },
    computed:
        Object.assign(
            mapState({
                order: state => state.creditaccount.order,
                customerWantsCreditAgreement: state => state.creditaccount.customerWantsCreditAgreement,
                preAuth: state => state.creditaccount.preAuth,
                totalCredit: state => state.creditaccount.creditAgreement.totalCredit,
                creditEvaluation: state => state.creditaccount.creditEvaluation,
                pageLoader: state => state.creditaccount.pageLoader
            }),
            mapGetters({
                orderTotalPrice: 'orderTotalPrice',
                creditPaymentSelected: 'creditPaymentSelected',
            }),
            {
                existingTFCustomerHeadingDescription: function () {
                    if (this.viewmodel.existingTFCustomerHeadingDescription == null) {
                        return this.viewmodel.existingTFCustomerHeadingDescription.replace("{AvailableCreditAmountDKK}", this.preAuth.availableAmount).replace("{TotalCreditDKK}", this.preAuth.creditLimit);
                    }
                    else {
                        return "";
                    }
                },
                approvedWithLowerLimitInsufficientFunds: function () {
                    let msg = this.viewmodel.creditEvaluationApprovedWithLowerLimitInsuffcientFundsMessage || '';
                    msg = msg.replace('{0}', this.creditEvaluation.creditCheckResult.requestedCreditLimit.toLocaleString('da-DK'));
                    msg = msg.replace('{1}', this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount.toLocaleString('da-DK'));
                    msg = msg.replace('{2}', (this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount - (this.preAuth.creditLimit - this.preAuth.availableAmount)).toLocaleString('da-DK'));
                    return msg;
                },
                approvedWithLowerLimitSufficientFunds: function () {
                    let msg = this.viewmodel.creditEvaluationApprovedWithLowerLimitSuffcientFundsMessage || '';
                    msg = msg.replace('{0}', this.creditEvaluation.creditCheckResult.requestedCreditLimit.toLocaleString('da-DK'));
                    msg = msg.replace('{1}', this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount.toLocaleString('da-DK'));
                    return msg;
                },
                acceptedCreditLimitText: function () {
                    let msg = this.viewmodel.creditEvaluationAcceptedMessage || '';
                    msg = msg.replace('{0}', this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount.toLocaleString('da-DK'));
                    return msg;
                },
                maxCreditLimitReachedText: function () {
                    let msg = this.viewmodel.creditEvaluationMaxCreditLimitReachedMessage || '';
                    msg = msg.replace('{0}', this.preAuth.creditLimit.toLocaleString('da-DK'));
                    msg = msg.replace('{1}', this.preAuth.availableAmount.toLocaleString('da-DK'));
                    return msg;
                },
                higherCreditLimitNeededText: function () {
                    let requiredLimit = this.recommendedCreditLimit() || 0;
                    const approvedAmount = this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;
                    let maxCreditLimit = approvedAmount + this.preAuth.availableAmount - this.preAuth.creditLimit;

                    let msg = this.viewmodel.creditEvaluationHigherCreditLimitNeededMessage || '';
                    msg = msg.replace('{0}', requiredLimit.toLocaleString('da-DK'));
                    msg = msg.replace('{1}', maxCreditLimit.toLocaleString('da-DK'));
                    return msg;
                }
            }
        )
}